import { render, staticRenderFns } from "./UsersDashboard.vue?vue&type=template&id=8f9a798e&scoped=true&lang=pug&"
import script from "./UsersDashboard.vue?vue&type=script&lang=ts&"
export * from "./UsersDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./UsersDashboard.vue?vue&type=style&index=0&id=8f9a798e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9a798e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
